import request from '../helpers/request';

const getRequestInvitationHours = async (data, errMsg) => {
  return await request.get(
    `/Request/invitation_hours`,
    data,
    errMsg || `При получении свободных часов для приемки произошла ошибка`
  );
};

export default getRequestInvitationHours;
